module.exports = __webpack_public_path__ + "img/card_header.763bb82c.png";